import { SiWhatsapp } from "react-icons/si";

export function WhatsAppFab() {
  const phoneNumber = "96551470470";
  const whatsappUrl = `https://wa.me/${phoneNumber}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 end-6 z-50 flex items-center justify-center w-14 h-14 bg-[#25D366] text-white rounded-full shadow-lg hover:bg-[#20BD5A] hover:scale-110 transition-all duration-300"
      data-testid="button-whatsapp-fab"
      aria-label="Chat on WhatsApp"
    >
      <SiWhatsapp className="w-7 h-7" />
    </a>
  );
}
